export const FILE_NAME_AND_TYPES = [
  ['plain/text', 'test.txt'],
  ['image/jpeg', 'image.jpg'],
  ['audio/mp3', 'audio.mp3'],
  ['video/mp4', 'video.mp4'],
];

export const TOAST_TYPE = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  INFO: 'INFO',
};

export const FILE_REJECTION_ERROR_CODE = {
  FileInvalidType: 'file-invalid-type',
  FileTooLarge: 'file-too-large',
  FileTooSmall: 'file-too-small',
  TooManyFiles: 'too-many-files',
};

//USED IN CATEGORY UPLOADER URL
export const CATEGORY_UPLOADER = 'category-uploader';

//JOB STATUS
export const RUNNING_JOB_STATUS = 'running';
export const SUCCESS_JOB_STATUS = 'success';
export const STOPPED_JOB_STATUS = 'stopped';
export const PAUSED_JOB_STATUS = 'paused';
export const FINISHED_JOB_STATUS = 'finished';
export const FAILED_JOB_STATUS = 'failed';
export const JOB_IS_RUNNING_JOB_STATUS = 'job is running. loading images';

//FILE STATUS
export const DUPLICATE_RECORD_FILE_STATUS = 't';

export const ALL_END_JOB_STATUS = [
  PAUSED_JOB_STATUS,
  FAILED_JOB_STATUS,
  FINISHED_JOB_STATUS,
  STOPPED_JOB_STATUS,
  SUCCESS_JOB_STATUS,
];

export const COPY_ROW_DOWNWARDS = 'COPY_ROW_DOWNWARDS';
export const COPY_ROW_UPWARDS = 'COPY_ROW_UPWARDS';
export const COPY_ROW_OTHERS = 'COPY_ROW_OTHERS';
export const COPY_CELL_UPWARDS = 'COPY_CELL_UPWARDS';
export const COPY_CELL_DOWNWARDS = 'COPY_CELL_DOWNWARDS';
export const COPY_CELL_OTHERS = 'COPY_CELL_OTHERS';

export const LOADING_STATUS = {
  QUEUED: 'QUEUED',
  UPLOADING: 'UPLOADING',
  UPLOADED: 'UPLOADED',
  FAILED: 'FAILED',
  FAILED_DUPLICATED: 'FAILED_DUPLICATED',
};

export const JPG = 'image/jpeg'; // JPEG image
export const PNG = 'image/png'; // PNG image
export const GIF = 'image/gif'; // GIF image
export const SVG = 'image/svg+xml'; // SVG image
export const WEBP = 'image/webp'; // WebP image

export const AVI = 'video/x-msvideo'; // AVI video
export const MP4 = 'video/mp4'; // MP4 video
export const MOV = 'video/quicktime'; // MOV video
export const WMV = 'video/x-ms-wmv'; // WMV video

export const MP3 = 'audio/mpeg'; // MP3 audio
export const WAV = 'audio/wav'; // WAV audio
export const OGG = 'audio/ogg'; // OGG audio

export const PDF = 'application/pdf'; // PDF document
export const DOC = 'application/msword'; // DOC document
export const DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; // DOCX document
export const TXT = 'text/plain'; // TXT document

// Use the constants in the array
export const IMAGE_FILE_TYPES = [
  JPG, // JPEG image
  PNG, // PNG image
  GIF, // GIF image
  SVG, // SVG image
  WEBP, // WebP image
];

export const VIDEO_FILE_TYPES = [
  MP4, // MP4 video
  AVI, // AVI video
  MOV, // MOV video
  WMV, // WMV video
];

export const AUDIO_FILE_TYPES = [
  MP3, // MP3 audio
  WAV, // WAV audio
  OGG, // OGG audio
];

export const DOCUMENT_FILE_TYPES = [
  PDF, // PDF document
  DOC, // DOC document
  DOCX, // DOCX document
  TXT, // TXT document
];
